import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import homeIcon from "../images/JILI-FORTUNE-RUSH_HOME.webp";
import termsIcon from "../images/JILI-FORTUNE-RUSH_T&C.webp";
import jiliSlotIcon from "../images/JILI-FORTUNE-SLOT.webp";

const menuItems = [
	{
		id: "home",
		image: homeIcon,
		x: -90,
		y: -75,
	},
	{
		id: "jili",
		image: jiliSlotIcon,
		x: -10,
		y: -95,
	},
	{
		id: "terms",
		image: termsIcon,
		x: 70,
		y: -75,
	},
];

export default function RadialNavigation({ onHome, onTerms, onJili }) {
	const [isOpen, setIsOpen] = useState(true);

	const handleItemClick = (id) => {
		setIsOpen(false);

		if (id === "home") {
			onHome?.();
			return;
		}

		if (id === "terms") {
			onTerms?.();
		}

		if (id === "jili") {
			onJili?.();
		}
	};

	return (
		<div className="radial-nav">
			<AnimatePresence>
				{isOpen &&
					menuItems.map((item, index) => (
						<motion.button
							key={item.id}
							type="button"
							className="radial-nav__item"
							aria-label={item.label}
							initial={{
								x: 0,
								y: 0,
								scale: 0,
								opacity: 0,
							}}
							animate={{
								x: item.x,
								y: item.y,
								scale: 1,
								opacity: 1,
							}}
							exit={{
								x: 0,
								y: 0,
								scale: 0,
								opacity: 0,
							}}
							transition={{
								type: "spring",
								stiffness: 420,
								damping: 24,
								delay: index * 0.06,
							}}
							whileHover={{
								scale: 1.08,
							}}
							whileTap={{
								scale: 0.92,
							}}
							onClick={() => handleItemClick(item.id)}
						>
							<img src={item.image} alt={item.label} draggable="false" />
						</motion.button>
					))}
			</AnimatePresence>

			{/* CENTER BUTTON */}
			<motion.button
				type="button"
				className={`radial-nav__toggle ${isOpen ? "is-open" : ""}`}
				aria-label={isOpen ? "Close menu" : "Open menu"}
				aria-expanded={isOpen}
				whileHover={{ scale: 1.08 }}
				whileTap={{ scale: 0.9 }}
				onClick={() => setIsOpen((prev) => !prev)}
			>
				<motion.span
					className="radial-nav__plus"
					animate={{
						rotate: isOpen ? 45 : 0,
					}}
					transition={{
						type: "spring",
						stiffness: 500,
						damping: 28,
					}}
				>
					+
				</motion.span>
			</motion.button>
		</div>
	);
}
